import React from "react";
import ReactDOM from 'react-dom';
import HubspotForm from 'react-hubspot-form';
import SalesForceEmailToBook from "./SalesForceEmailToBook";

export default function EmailToBookModal(props) {
    return (
        <div className="modal fade" id="email-book-modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{maxWidth: "700px"}}>
                <div className="modal-content">
                    <div className="modal-header pb-0 border-none">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {
                            props.data.active_site.domain == 'www.discover-bahamas.com' &&
                            <div>
                                <h5 className="font-supersized font-weight-bold mb-4">Contact Us to Book</h5>
                                <HubspotForm
                                    portalId='6893926'
                                    formId='2c03d252-25c0-4489-9557-9807c7d935f1'
                                    onSubmit={() => console.log('Submit!')}
                                    onReady={(form) => console.log('Form ready!')}
                                    region="na1"
                                    loading={<p className="body-text-color">Loading...</p>}
                                />
                            </div>
                        }
                        {
                            props.data.active_site.domain == 'www.islandroutes.com' &&
                            <SalesForceEmailToBook />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}


if (document.getElementById('emailToBookMenu')) {
    
    const element = document.getElementById('contactUsMenu');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);   
    
    ReactDOM.render(<EmailToBookModal data={JSON.parse(data.data)} />, document.getElementById('emailToBookMenu'));
}


// WEBPACK FOOTER //
// ./resources/js/components/EmailToBookModal/index.js